import { createContext, useContext } from 'react';

/** For more details on
 * `authContext`, `ProvideAuth`, `useAuth` and `useProvideAuth`
 * refer to: https://usehooks.com/useAuth/
 */
export const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);
